import '@styles/webdesktop/stylesheets/typography.scss';
import React from 'react';
import { TypographyLevel } from './TypographyLevel';
const typeToTag = {
    [TypographyLevel.BodyXs]: 'span',
    [TypographyLevel.BodySm]: 'span',
    [TypographyLevel.BodyMd]: 'span',
    [TypographyLevel.Paragraph]: 'p'
};
export const Typography = ({ children, className = '', level = TypographyLevel.BodyMd, noWrap = false }) => {
    const Tag = typeToTag[level];
    const typographyClassNames = ['typography', `typography-${level}`, noWrap ? 'typography-nowrap' : '', className];
    const typographyClassName = typographyClassNames.filter(Boolean).join(' ');
    return React.createElement(Tag, { className: typographyClassName }, children);
};
